module.exports = __webpack_public_path__ + "img/-LV55SsE-DWUum7DP3zC.acc5e54b.jpg";